import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import Routes from '../constants/Routes';

import CMPCookiesList from './CMPCookiesList';
import CMPCookieDetails from './ThirdPartyDetails/CMPCookieDetails';

const propTypes = {
    location: PropTypes.object.isRequired,
};

export class CMPModalContent extends Component {

    render() {
        const {
            location,
        } = this.props;
        return (
            <Switch location={location}>
                <Route
                    path={Routes.COOKIE_DETAILS.link}
                    component={CMPCookieDetails}
                />
                <Route
                    path={Routes.COOKIES_LIST.link}
                    component={CMPCookiesList}
                />
                <Redirect to={Routes.COOKIES_LIST.link} />
            </Switch>
        );
    }

}

CMPModalContent.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        location: ownProps.location || getLocationSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(CMPModalContent);
